/** @jsxImportSource @emotion/react */
import { css } from '@emotion/core'
import { gsColors } from './Variables.js'

const GlobalStyles = css`
  scroll-behavior: smooth;

  :root {
    --font-euclid: 'Euclid', sans-serif;
    --font-brown: 'Brown', sans-serif;
    --font-garnett: 'Garnett', sans-serif;
  }

  html {
    box-sizing: border-box;
    font-size: 100%;
    scroll-behavior: smooth;
    font-family: var(--font-brown);


    .react-datepicker {
      font-family: var(--font-brown) !important;
    }
  }

  html:focus-within {
    scroll-behavior: smooth;
  }

  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }

  body {
    background-color: ${gsColors.white};
    color: ${gsColors.black};
    font-family: var(--font-brown), sans-serif;
    font-weight: normal;
    line-height: 1.625;
    margin: 0;
    padding: 0;
    overflow-x: hidden;
  }

  [data-af-custom-fonts="af-creatives-text"] {
      font-family: var(--font-brown), sans-serif;
  }


  h1,
  h2,
  p,
  ul {
    margin: 0;
    padding: 0;
  }

  ul {
    list-style: none;
  }

  .show {
    display: block !important;
  }

  .hide {
    display: none !important;
  }

  /* Hide iOS-only app-install prompts for mobile non-iOS users. The
     hide-app-prompts class is added to <html> pre-paint in _document.js
     (it is HIDE_CLASS from src/helpers/deviceDetection.js). The
     app-install-prompt marker class is applied directly by each prompt
     component (footer, how-it-works/BookCTA, book/steps/Six). CSS can't
     import JS, so if either name is renamed, update this selector too. */
  html.hide-app-prompts .app-install-prompt {
    display: none !important;
  }

  /* Google Autocomplete */
  .pac-container {
    z-index: 10001 !important;
  }

  /* Lock background scroll while a react-modal is open */
  body.ReactModal__Body--open {
    overflow: hidden;
  }

  /* Native-style slide-up for the booking location sheet. The portal class is
     applied only on mobile by BookingLocationModal (desktop passes undefined and
     keeps react-modal's default, transition-free behavior); scoping under it
     leaves every other modal untouched.

     The entrance is a @keyframes animation on the base content class (present
     from first paint, so no flash) rather than a transform that persists on
     --after-open. A transform left on the resting sheet promotes it to its own
     composited layer, and on iOS Safari that layer swallows touch hit-testing
     for Google's body-level .pac-container, making address suggestions
     untappable. Keyframes leave no transform once the sheet is at rest. */
  @media (max-width: 768px) {
    .location-sheet-portal .ReactModal__Overlay {
      opacity: 0;
      transition: opacity 300ms ease;
    }

    .location-sheet-portal .ReactModal__Overlay--after-open {
      opacity: 1;
    }

    .location-sheet-portal .ReactModal__Overlay--before-close {
      opacity: 0;
    }

    .location-sheet-portal .ReactModal__Content {
      animation: locationSheetIn 300ms ease;
    }

    .location-sheet-portal .ReactModal__Content--before-close {
      animation: locationSheetOut 300ms ease forwards;
    }

    @keyframes locationSheetIn {
      from {
        transform: translateY(100%);
      }
      to {
        transform: translateY(0);
      }
    }

    @keyframes locationSheetOut {
      from {
        transform: translateY(0);
      }
      to {
        transform: translateY(100%);
      }
    }
  }

  #root {
    display: flex;
    flex-direction: column;
    height: 100vh;
  }

  .booking-flow {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  .react-datepicker__day--selected {
    background-color: ${gsColors.grape};
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover, 
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    -webkit-text-fill-color: black;
    -webkit-box-shadow: 0 0 0px 1000px #FFFFFF inset;
    // transition: background-color 5000s ease-in-out 0s;
  }
`

export default GlobalStyles
